import apiV2 from '../api/v2';

// Practice-level risk flag, set by admins from the practice detail page (see
// components/accounts/practice/details/fieldDefinitions.ts's 'risk' group).
// 'normal' is the implicit default - a practice never appears in the
// risk-statuses list below unless it's warning/at_risk (see
// fetchPracticeRiskStatuses).
export type PracticeRiskStatus = 'normal' | 'warning' | 'at_risk';

export interface PracticeRiskEntry {
    id: string;
    name: string;
    riskStatus: Exclude<PracticeRiskStatus, 'normal'>;
    riskNote: string | null;
}

/**
 * GET /practices/risk-statuses - admin-authed, returns ONLY practices
 * currently flagged warning/at_risk (a practice absent from this list is
 * normal). Backs the global risk-coloring lookup used across the app - see
 * hooks/usePracticeRiskStatuses.ts.
 */
export async function fetchPracticeRiskStatuses(): Promise<PracticeRiskEntry[]> {
    const response = await apiV2.get<{ success: boolean; data: PracticeRiskEntry[] }>(
        '/practices/risk-statuses'
    );
    return response.data.data;
}
